/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  'use strict';

  /* ---------- Animated stat counters (e.g. "146K+ Musicians Strong") ---------- */
  function animateCounters() {
    var headings = document.querySelectorAll('.column__heading');
    var pattern = /^([\d,]+)(.*)$/;

    headings.forEach(function(el) {
      if (el.dataset.dortiCounterInit) return;
      var text = el.textContent.trim();
      var match = text.match(pattern);
      if (!match) return;

      var digitsOnly = match[1].replace(/,/g, '');
      var target = parseInt(digitsOnly, 10);
      if (isNaN(target) || target < 2) return;

      var suffix = match[2];
      var hasComma = match[1].indexOf(',') !== -1;

      el.dataset.dortiCounterInit = 'true';
      el.classList.add('dorti-counter');

      if (!('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            runCount(el, target, suffix, hasComma);
            observer.disconnect();
          }
        });
      }, { threshold: 0.4 });
      observer.observe(el);
    });
  }

  function runCount(el, target, suffix, hasComma) {
    var duration = 1400;
    var startTime = null;
    var finished = false;
    var finalText = (hasComma ? target.toLocaleString('en-US') : String(target)) + suffix;

    function finish() {
      if (finished) return;
      finished = true;
      el.textContent = finalText;
    }

    function step(timestamp) {
      if (finished) return;
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      var display = hasComma ? current.toLocaleString('en-US') : String(current);
      el.textContent = display + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        finish();
      }
    }

    // Safety net: if rAF stalls or the tab is backgrounded mid-animation,
    // guarantee the correct final value still lands.
    window.setTimeout(finish, duration + 400);
    window.requestAnimationFrame(step);
  }

  /* ---------- Hero mouse-parallax tilt ---------- */
  function initHeroParallax() {
    var containers = document.querySelectorAll('[data-dorti-hero-parallax]');
    if (!containers.length) return;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return; // skip on touch devices

    containers.forEach(function(container) {
      if (container.dataset.dortiParallaxInit) return;
      container.dataset.dortiParallaxInit = 'true';

      container.addEventListener('mousemove', function(e) {
        var image = container.querySelector('[data-dorti-hero-image]');
        if (!image) return;
        var rect = container.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        var moveX = x * 16;
        var moveY = y * 16;
        image.style.transform = 'translate3d(' + moveX.toFixed(1) + 'px, ' + moveY.toFixed(1) + 'px, 0) scale(1.05)';
      });

      container.addEventListener('mouseleave', function() {
        var image = container.querySelector('[data-dorti-hero-image]');
        if (image) image.style.transform = '';
      });
    });
  }

  /* ---------- Scroll-linked spin (e.g. the guitar strap medallion) ---------- */
  function initScrollSpin() {
    var elements = document.querySelectorAll('[data-dorti-spin]');
    if (!elements.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;

    function update() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      elements.forEach(function(el) {
        var speed = parseFloat(el.dataset.dortiSpinSpeed) || 0.15;
        var angle = scrollY * speed;
        el.style.transform = 'rotate(' + angle + 'deg)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    animateCounters();
    initHeroParallax();
    initScrollSpin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    animateCounters();
    initHeroParallax();
    initScrollSpin();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
